import styled from 'styled-components';
import { colors } from 'styles/colors';
import { SelectMultiple } from 'components';

export const Table = styled.table`
  white-space: nowrap;
  & td,th {
    padding: 3px 10px;
    border: 1px solid grey;
  }
`;

export const FileInput = styled.label`
  border-radius: 32px;
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
  font-size: 1em;
  font-weight: bold;
  outline: none;
  padding: 8px 0;
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
  box-shadow: 0 7px 12px rgba(83, 104, 111, 0.12), 0 11px 15px rgba(85, 97, 115, 0.1);
  background-color: ${colors.Pink200};
  border-color: ${colors.Pink200};
  color: ${colors.White};
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: ${colors.Pink300};
    border-color: ${colors.Pink300};
    box-shadow: 0 7px 12px rgba(83, 104, 111, 0.35), 0 11px 15px rgba(85, 97, 115, 0.25);
  }
`;

export const CustomSelect = styled(SelectMultiple)`
  margin-bottom: 20px;
`;

export const BottonTypeSolution = styled.div<{ isClicked }>(
  ({ isClicked }) => `
  width: 149px;
  height: ${isClicked ? '35px' : '34px'};
  border-radius: 8px 8px 0 0;
  border: 1px solid #D7D7D7;
  border-bottom: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${isClicked ? '#FFFFFF' : '#F4F4F4'};
  `,
);

export const PreFillGuideArea = styled.div`
  border: 1px solid #D7D7D7;
  position: relative;
`;

export const ContainerExportationAndDowload = styled.div`
  padding-left: 20px;
  h3 {
    font-size: 16px;
    padding-bottom: 10px;
  }
  h5 {
    font-size: 12px;
    font-weight: bold;
  }
  section {
    background: #F4F4F4;
    border-radius: 10px;
    padding: 20px;
  }
`;

export const ContainerUnitMachine = styled.div`
  width: 100%;
  td {
    display: flex;
  }
`;

export const StyleSelect = styled.div<{ hasSelected? }>(
  ({ hasSelected }) => `
  min-height: 48px;
  margin: 0;
  font-size: 12px;
  color: #000;
  width: 100%;
  max-width: 500px;
  border: 1px solid #E9E9E9;
  border-radius: 5px;
  box-sizing: border-box !important;
  display: inline-flex;
  div {
    div {
      span {
      top: 50%;
      font-size: 12px;
      color: #9fa098;
      margin-top: 0;
    }
    }
  }
  .placeholderName {
    font-size: ${hasSelected ? '0px' : '12px'};
  }
`,
);

export const Label = styled.span`
  transition: all 0.2s;
  margin-top: -6px;
  margin-left: 16px;
  margin-right: 16px;
  color: ${colors.Blue700};
  font-size: 11px;
  font-weight: bold;
  z-index: 2;
`;

export const CheckboxSelectAll = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  div {
    border: 1px solid gray;
    width: 10px;
    height: 10px;
  }
`;

export const BorderSubItem = styled.div`
  border-left: 1px dashed #D0D0D0;
  height: 373px;
  position: absolute;
  top: -61px;
  left: 21px;
  z-index: 10;
`;
